import { useDisableSubnav } from '@monorepo/shared/hooks/subnav/useDisableSubnav';
import { FormTemplateResponse } from 'mapistry-shared';
import React, { useCallback, useEffect, useState } from 'react';
import { getPathToHome } from '../../../../shared/routing';
import { FormTemplateEditor } from '../FormTemplateEditor/FormTemplateEditor';
import { GenerateFormTemplateInputs } from './GenerateFormTemplateInputs';
import { useGenerateFormTemplateFromPdfAndListenForPushMessageResponse } from './hooks/useGenerateFormTemplateFromPdfAndListenForPushMessageResponse';
import { useSaveNewFormTemplate } from './hooks/useSaveNewFormTemplate';

export function GenerateFormTemplatePage() {
  useDisableSubnav();
  const closeUrl = getPathToHome();
  const [formTemplateSlug, setFormTemplateSlug] = useState('');
  const [isDirty, setIsDirty] = useState(false);

  const {
    processedFormTemplate,
    isProcessingImage,
    handleUploadFormImage,
    startedProcessingAt,
  } = useGenerateFormTemplateFromPdfAndListenForPushMessageResponse();

  const [saveNewFormTemplate, { isLoading: isSavingTemplate }] =
    useSaveNewFormTemplate();

  const handleSaveFormTemplate = useCallback(
    async (formTemplate: FormTemplateResponse) => {
      if (!formTemplateSlug) return;
      const formTemplateWithUserDefinedSlug = {
        ...formTemplate,
        slug: formTemplateSlug,
      };
      await saveNewFormTemplate(formTemplateWithUserDefinedSlug);
    },
    [formTemplateSlug, saveNewFormTemplate],
  );

  useEffect(() => {
    setIsDirty(!!formTemplateSlug && !!processedFormTemplate);
  }, [formTemplateSlug, processedFormTemplate]);

  const noOpSetIsDirty = useCallback(() => {
    // editing the processedFormTemplate in the UI does not impact whether or not it's saveable
  }, []);

  return (
    <FormTemplateEditor
      beginningFormTemplate={processedFormTemplate}
      closeUrl={closeUrl}
      titleVerb="Generating"
      handleSaveFormTemplate={handleSaveFormTemplate}
      isSubmitting={isSavingTemplate}
      isDirty={isDirty}
      setIsDirty={noOpSetIsDirty}
      sidebarWidth="50%"
      sidebarComponent={
        <GenerateFormTemplateInputs
          formTemplateSlug={formTemplateSlug}
          handleUpload={handleUploadFormImage}
          isProcessingImage={isProcessingImage}
          setFormTemplateSlug={setFormTemplateSlug}
          startedProcessingAt={startedProcessingAt}
        />
      }
    />
  );
}
